module.exports = __webpack_public_path__ + "static/banner-mobile-66e8e2484004d4c7fe9ab6746cbf1031.png";